import React from "react";
import { FormFrame } from "@/components/common/FormFrame";

// Portugal intake form (public/portugal-form.html), shown under the site header.
export const PortugalApplyPage = () => <FormFrame src="/portugal-form.html" title="Portugal application form" testid="portugal-apply-page" />;

export default PortugalApplyPage;
